/**
 * Card Layout JS controller. Handles hiding and toggling content + its arias.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class CardLayout
 */
class CardLayout {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Cache the wysiwyg -fields and buttons to toggle them
        this.cardWysiwyg         = $( '.js-card-wysiwyg' );
        this.toggleWysiwygButton = $( '.js-toggle-wysiwyg' );

        // Cache strings to control "show more" / "show less"
        this.strings             = themeData.themeStrings.card_layout;

    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        /**
         * When clicking a wysiwygs toggle button, get its aria-expanded -status and the wysiwyg it
         * controls (by aria-controls attribute), then run a function to toggle the wanted
         * wysiwyg field to be visible / not visible
         */
        this.toggleWysiwygButton.each( ( index, toggleButton ) => {

            // Get the clicked element, set a click handler
            const clickedElement = $( toggleButton );

            clickedElement.on( 'click', ( e ) =>  {

                // Get the wysiwyg its linked to with aria-controls
                const wysiwygName = clickedElement.attr( 'aria-controls' );

                // Get the ariaStatus of the clicked element in order to alter it
                const ariaStatus = clickedElement.attr( 'aria-expanded' );

                this.togglerController( clickedElement, ariaStatus, wysiwygName );

            });
        });

    }

    /**
     * Hide all wysiwyg elements which are meant to be toggled open
     */
    hideWysiwygs() {
        this.cardWysiwyg.addClass( 'js-hidden' );
    }

    /**
     * Control aria-expanded to be truthful, change span according to aria-expanded status,
     * toggle js-hidden class to wysiwyg
     *
     * @param { string } clickedElement
     * @param { string } ariaStatus
     * @param { string } wysiwygName
     */
    togglerController( clickedElement, ariaStatus, wysiwygName ) {

        // Get the button, its content and the angle -icon
        const clickedElementTexts = clickedElement.children( 'span' );
        const clickedElementIcon  = clickedElement.children( 'i' );

        // If not expanded, change to expanded and change the buttons string to 'Show less'
        if ( ariaStatus == 'false' ) {
            clickedElement.attr( 'aria-expanded', 'true' );
            clickedElementTexts.text( this.strings.show_less );
        } else {

            // If expanded, change to not expanded and change the buttons string back to 'Show more'
            clickedElement.attr( 'aria-expanded', 'false' );
            clickedElementTexts.text( this.strings.show_more );
        }

        // Toggle the wysiwyg visible / not visible, the id comes from the
        // buttons aria-controls attribute
        $( '#' + wysiwygName ).toggleClass( 'js-hidden' );

        // Rotate the icon by toggling a class
        clickedElementIcon.toggleClass( 'fa-angle-down--rotate' );

    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.hideWysiwygs();

    }
}

// Export the class reference.
module.exports = CardLayout;



// WEBPACK FOOTER //
// ./assets/scripts/cardlayout.js